import type { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { RouterPath } from '@/models/enums'
import { activityTrackingService } from '@/services/ActivityTrackingService'
import { useAppStore } from '@/store/app'

import type { MenuItemProps } from './MenuItem.interface'

export const MenuItem: FC<MenuItemProps> = (props) => {
  const { children, icon, to, ...otherProps } = props
  const location = useLocation()
  const toggleMenu = useAppStore((state) => state.toggleMenu)
  const isActive = location.pathname === `/${RouterPath.Hub}/${to}`
  const linkClass = isActive ? 'sidebar__link active' : 'sidebar__link'

  const handleClickMenuItem = () => {
    activityTrackingService.trackMenuNavigationClick(to)
    toggleMenu(false)
  }

  return (
    <Link className={`sidebar__link ${linkClass}`} to={to} {...otherProps} onClick={handleClickMenuItem}>
      {icon && <div className="size-6">{icon}</div>}
      <div>{children}</div>
    </Link>
  )
}
